import urlHelper from '../helpers/url'

const primerAcceso = () => {
    console.log('primerAcceso' + document.querySelector(".next-button[data-step=combo_procesar_bonificado]").dataset.combo);
    let combo = document.querySelector(".next-button[data-step=combo_procesar_bonificado]").dataset.combo;
    if (combo && combo!=null)
    {
        urlHelper.redirectToCombo(combo)
    }
    else
    {
        window.mostrar_error( { 
            error: `primerAcceso.primerAcceso | No se encontro el combo bonificado` 
        })
    }

}

export default primerAcceso;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/primerAcceso.js